module.exports = __webpack_public_path__ + "static/media/tatibana_shun_update25d6c55fd16f7a77c3a55fcbcdba3d17.webp";